import {nothingSelector} from 'services/utils/selectors/nothingSelector';
import {useAppSelector} from 'store/hooks';
import type {WorkV4} from '../types';
import {selectMetadataEditEditedWorkSelector} from '../metadataEditSlice';

export const useConditionalWorkEdit = (required: boolean): WorkV4 | undefined =>
  useAppSelector(
    required ? selectMetadataEditEditedWorkSelector : nothingSelector,
  );
